let $_http;

export function init$http($http) {
  $_http = $http;
}

export function get$http($http) {
  return $_http;
}

export function getAllGroups() {
  return get$http().get('/xtech/cgroup/allGroups');
}

export function getAllNodeByGroup(code = '') {
  return get$http().get('/xtech/cgroup/getGroupsNode', {
    params: {
      code,
      getSubNode: true
    }
  });
}

export function getAllAttrs(code = '') {
  return get$http().get('/xtech/cgroup/allGroupsAttr', {
    params: {
      code
    }
  });
}

export function getAllMembers(code = '') {
  return get$http().get('/xtech/cgroup/allGroupsMember', {
    params: {
      code
    }
  });
}

export function createNode(groupCode = '', nodeCode = '', nodeName = '', parentCode = '') {
  return get$http().post('/xtech/cgroup/issueGroupsNode', {
    code: groupCode,
    nodeCode: nodeCode,
    nodeName: nodeName,
    parent: parentCode
  });
}

export function addNewAttrToNode(groupCode = '', nodeCode = '', attrCode = []) {
  return get$http().post('/xtech/cgroup/mappingGroupsAttr', {
    code: groupCode,
    nodeCode,
    attrCode
  });
}

export function addNewMemberToNode(groupCode = '', nodeCode = '', memberCode = []) {
  return get$http().post('/xtech/cgroup/mappingGroupsMember', {
    code: groupCode,
    nodeCode,
    memberCode
  });
}

export function deleteNodeFromGroup(groupCode = '', nodeCode = '') {
  return get$http().post('/xtech/cgroup/deleteNode', {code: groupCode, nodeCode});
}

export function getAttrsByNode(groupCode = '', nodeCode = '', searchKey = '', pageNum = 1, pageSize = 20) {
  return get$http().post('/xtech/cgroup/getGroupsAttrPage', {
    code: groupCode,
    nodeCode: nodeCode,
    pageNo: pageNum,
    pageSize: pageSize,
    keyword: searchKey
  });
}

export function getMembersByNode(groupCode = '', nodeCode = '', searchKey = '', pageNum = 1, pageSize = 20) {
  return get$http().post('/xtech/cgroup/getGroupsMemberPage', {
    code: groupCode,
    nodeCode: nodeCode,
    pageNo: pageNum,
    pageSize: pageSize,
    keyword: searchKey
  });
}

export function delAttrsFromNode(groupCode = '', nodeCode = '', attrCodes = []) {
  return get$http().post('/xtech/cgroup/deleteGroupsAttr', {
    code: groupCode,
    nodeCode: nodeCode,
    attrCode: attrCodes
  });
}

export function delMembersFromNode(groupCode = '', nodeCode = '', memberCodes = []) {
  return get$http().post('/xtech/cgroup/deleteGroupsMember', {
    code: groupCode,
    nodeCode: nodeCode,
    memberCode: memberCodes
  });
}

export function editGroupNode(groupCode = '', nodeCode = '', nodeName = '', parent = '') {
  return get$http().post('/xtech/cgroup/editGroupsNode', {
    code: groupCode,
    nodeCode,
    nodeName,
    parent
  });
}

export function searchGroupsAttr(groupCode = '', fieldName = '', keyword = '') {
  return get$http().post('/xtech/cgroup/searchGroupsAttr', {
    code: groupCode,
    fieldName,
    keyword
  });
}

export function searchGroupsMembers(groupCode = '', fieldName = '', keyword = '') {
  return get$http().post('/xtech/cgroup/searchGroupsMember', {
    code: groupCode,
    fieldName,
    keyword
  });
}
